import useIsTouchDevice from 'hooks/useIsTouchDevice';
import useStore from '@/store/main/action';

interface SurveyLayoutProps {
    children: React.ReactNode;
}

const SurveyLayoutComponent = ({ children }: SurveyLayoutProps) => {
    const { isTouchDevice } = useIsTouchDevice();
    const { primaryColor } = useStore()

    if (isTouchDevice) {
        return (
            <div className="flex flex-1 flex-col items-center justify-center">
                <div
                    className={`
                        flex w-full flex-1 flex-col border-l-35 border-r-35 bg-default-50
                        px-8 pt-[8%] pb-5 shadow-md z-1
                        max-700px:border-l-15 max-700px:border-r-15 max-700px:px-3
                        max-h-[700px]:pt-2.5
                    `}
                    style={{ borderColor: `${primaryColor}` }}
                    
                >
                    {children}
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-1 items-start justify-center">
            <div
                className={`
                    flex w-[80%] max-w-225 flex-col rounded bg-default-50
                    border-l-20 border-r-20 mt-[5%] min-h-87.5
                    px-10 py-5 shadow-md z-1
                    max-[1263px]:w-[95%] max-[900px]:max-w-225
                `}
                style={{ borderColor: `${primaryColor}` }}
            >
                {children}
            </div>
        </div>
    );
};

export default SurveyLayoutComponent;
